import useFirestorage from '@/hooks/useFirestorage';
import { FC, use, useEffect, useState } from 'react';
import ImgUpload from './ImgUpload';
import { getFileRef } from '@/services/firebase';
import { uploadBytesResumable, UploadTask } from 'firebase/storage';

export interface Props {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
}

/**
 * UploadToStorage
 */
const UploadToStorage: FC<Props> = ({ onChange, name, ...props }) => {
  const [file, setFile] = useState<File>();
  const [uploadTask, setUploadTask] = useState<UploadTask>();
  const { progress, loading, error, fileUrl } = useFirestorage(uploadTask);

  const onInnerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const selectedFile = files[0];
    setFile(selectedFile);
  };

  useEffect(() => {
    if (fileUrl) {
      onChange?.({ target: { value: fileUrl, name } } as React.ChangeEvent<HTMLInputElement>);
    }
  }, [fileUrl]);

  useEffect(() => {
    if (!file) return;
    const filePrefix = crypto.randomUUID();
    const storageRef = getFileRef(`temporal/${filePrefix}_${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    setUploadTask(uploadTask);
  }, [file]);

  return (
    <ImgUpload
      name={name}
      progress={progress}
      loading={loading}
      imgUrl={fileUrl}
      error={error}
      {...props}
      onChange={onInnerChange}
    />
  );
};

export default UploadToStorage;
